import React from 'react';
import { Accordion, Table } from 'semantic-ui-react';
import SimpleAccordion from '@/components/accordion/SimpleAccordion';
import events from '../hooks/events';
import DatasetMetricsTable from '../../metrics/components/DatasetMetricsTable';
import DictionariesMetricsTable from '../../metrics/components/DictionariesMetricsTable';
import DatasetConditionsTable from '../../conditions/containers/DatasetConditionsTable';
import DatasetCollectionsTable from '../../collections/containers/DatasetCollectionsTable';
import DatasetSettingsTable from './DatasetSettingsTable';
import DatasetBasicSettingRows from '../containers/DatasetBasicSettingRows';
import DatasetCohortSettingRows from '../containers/DatasetCohortSettingRows';
import DatasetSubscriptionSettingRows from '../containers/DatasetSubscriptionSettingRows';
import DatasetRequestSettingRows from '../containers/DatasetRequestSettingRows';

const DatasetAdminAccordion = ({
  category,
  code,
  hideCatalogue,
  hideMetrics,
  name,
  panels,
  datasourceSupportsCohort,
}) => {
  const updatePanels = events.useUpdateDatasetSettingsPanels(category, { code });
  return (
    <Accordion>
      <SimpleAccordion
        active={panels.single.includes(0)}
        headerId="dataset.settings.custom.actions.title"
        index={0}
        onClick={() => updatePanels({ index: 0, panel: 'single' })}
      >
        <DatasetSettingsTable>
          <Table.Body>
            <DatasetBasicSettingRows code={code} category={category} hideCatalogue={hideCatalogue} name={name} />
          </Table.Body>
        </DatasetSettingsTable>
      </SimpleAccordion>
      {datasourceSupportsCohort && (
        <SimpleAccordion
          active={panels.single.includes(1)}
          headerId="dataset.settings.cohort.title"
          index={1}
          onClick={() => updatePanels({ index: 1, panel: 'single' })}
        >
          <DatasetSettingsTable>
            <Table.Body>
              <DatasetCohortSettingRows code={code} category={category} name={name} />
            </Table.Body>
          </DatasetSettingsTable>
        </SimpleAccordion>
      )}
      <SimpleAccordion
        active={panels.single.includes(2)}
        headerId="dataset.settings.subscriptions.title"
        index={2}
        onClick={() => updatePanels({ index: 2, panel: 'single' })}
      >
        <DatasetSettingsTable>
          <Table.Body>
            <DatasetSubscriptionSettingRows code={code} category={category} />
          </Table.Body>
        </DatasetSettingsTable>
      </SimpleAccordion>
      {!hideMetrics && (
        <>
          <SimpleAccordion
            active={panels.single.includes(3)}
            headerId="dataset.settings.metrics.title"
            index={3}
            onClick={() => updatePanels({ index: 3, panel: 'single' })}
          >
            <DatasetMetricsTable code={code} category={category} />
          </SimpleAccordion>
          <SimpleAccordion
            active={panels.single.includes(4)}
            headerId="dataset.settings.metrics.dictionaries.title"
            index={4}
            onClick={() => updatePanels({ index: 4, panel: 'single' })}
          >
            <DictionariesMetricsTable code={code} category={category} />
          </SimpleAccordion>
        </>
      )}
      <SimpleAccordion
        active={panels.single.includes(5)}
        headerId="dataset.settings.requests.title"
        index={5}
        onClick={() => updatePanels({ index: 5, panel: 'single' })}
      >
        <DatasetSettingsTable>
          <Table.Body>
            <DatasetRequestSettingRows code={code} category={category} name={name} />
          </Table.Body>
        </DatasetSettingsTable>
      </SimpleAccordion>
      <SimpleAccordion
        active={panels.single.includes(6)}
        headerId="dataset.settings.conditions.title"
        index={6}
        onClick={() => updatePanels({ index: 6, panel: 'single' })}
      >
        <DatasetConditionsTable code={code} category={category} name={name} />
      </SimpleAccordion>
      <SimpleAccordion
        active={panels.single.includes(7)}
        headerId="dataset.settings.collections.title"
        index={7}
        onClick={() => updatePanels({ index: 7, panel: 'single' })}
      >
        <DatasetCollectionsTable code={code} category="settings" name={name} />
      </SimpleAccordion>
    </Accordion>
  );
};

export default DatasetAdminAccordion;
